import "./App.css";
import Home from "./components/Home/Home";
import Navbar from "./components/Common/Navbar";
import Footer from "./components/Common/Footer";
import { Route, Routes } from "react-router-dom";
import CommingSoon from "./components/Common/CommingSoon";
import AboutPage from "./components/About/AboutPage";
import TestimonialPage from "./components/TestimonialCarousel/TestimonialPage";
import ContactUs from "./components/ContactUS/ContactUs";
import Login from "./components/Login/Login";
import SnackbarComponent from "./components/Common/SnackbarComponent";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import AddStudent from "./components/AdminDashboard/AddStudent";
import AddTeacher from "./components/AdminDashboard/AddTeacher";
import TeacherDashboard from "./components/TeacherDashboard/TeacherDashboard";
import AddScore from "./components/TeacherDashboard/AddScore";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import UnauthorizedPage from "./components/Auth/Unauthorized";
import NotFoundPage from "./components/Auth/NotFound";
import StudentDashboard from "./components/StudentDashboard/StudentDashboard";
import PrivacyPolicy from "./components/Common/PrivacyPolicy";

function App() {
  return (
    <>
      <Navbar />
      <SnackbarComponent />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <div className="container">
              <Home />
            </div>
          }
        />
        <Route path="/commingSoon" element={<CommingSoon />} />
        <Route path="/aboutus" element={<AboutPage />} />
        <Route path="/testimonial" element={<TestimonialPage />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route
          component={
            <div className="container">
              <Home />
            </div>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route
          path="/adminDashboard"
          element={
            <ProtectedRoute
              element={<AdminDashboard />}
              allowedRoles={["Admin"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route
          path="/addStudent"
          element={
            <ProtectedRoute
              element={<AddStudent />}
              allowedRoles={["Admin"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route
          path="/addTeacher"
          element={
            <ProtectedRoute
              element={<AddTeacher />}
              allowedRoles={["Admin"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route
          path="/teacherDashboard"
          element={
            <ProtectedRoute
              element={<TeacherDashboard />}
              allowedRoles={["Teacher", "Admin"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route
          path="/addScore"
          element={
            <ProtectedRoute
              element={<AddScore />}
              allowedRoles={["Teacher", "Admin"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route
          path="/studentDashboard"
          element={
            <ProtectedRoute
              element={<StudentDashboard />}
              allowedRoles={["Teacher", "Admin", "Student"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
        <Route
          path="/studentDashboard/:id"
          element={
            <ProtectedRoute
              element={<StudentDashboard />}
              allowedRoles={["Teacher", "Admin", "Student"]}
              userRole={sessionStorage.getItem("role")}
            />
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
